/* global I18n */

import {Controller} from "@hotwired/stimulus"
import $ from "cash-dom"

class FactsTableController extends Controller {
  connect() {
    tableQuiz(this.element)
  }
}

function tableQuiz(table) {
  const $table = $(table)
  const $cells = $table.find("td").not(":first-child")

  function startQuiz() {
    $cells.each(function() {
      $(this)
        .wrapInner("<div class='facts-table__cover'><div>")
        .find(".facts-table__cover")
        .on("click", function() {
          uncover.call(this)
          if (quizIsFinished()) {
            $table.find(".start-table-quiz").text(I18n.t("js.table_quiz"))
          }
        })
    })
  }

  function quizIsFinished() {
    return !$table.find(".facts-table__cover").length
  }

  function endQuiz() {
    $table.find(".facts-table__cover").each(uncover)
  }

  function uncover() {
    $(this).parent().html($(this).html())
    $(this).remove()
  }

  const $caption = $table.find("caption")
  if (!$caption.find(".facts-table__title").length) {
    $caption
      .wrapInner("<div class='facts-table__title'><div>")
      .find(".facts-table__title")
      .append(`<a class="start-table-quiz">${I18n.t("js.table_quiz")}</a>`)
  }
  $caption
    .find(".start-table-quiz")
    .on("click", function() {
      if ($(this).text() === I18n.t("js.table_quiz")) {
        $(this).text(I18n.t("js.reveal_all"))
        startQuiz()
      } else {
        $(this).text(I18n.t("js.table_quiz"))
        endQuiz()
      }
    })
}

export default FactsTableController
